
/**
 * yyyyMMddHHmm 形式の数字列にマッチする正規表現
 */
const timeCodeRegExp = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})$/;

/**
 * タイムコードを年月日時分に分割して返す関数
 * @param timeCode yyyyMMddHHmm 形式のタイムコード文字列
 * @return timeCode を分割して 年(year)、月(month)、日(day)、時(hour)、分(minute) に格納したオブジェクト
 */
export const parseTimeCode = (timeCode: string) => {
  try {
    const [ _, year, month, day, hour, minute ] = timeCodeRegExp.exec(timeCode);

    return {
      year,
      month,
      day,
      hour,
      minute
    };
  } catch (err) {
    console.error("invalid timeCode is given: " + timeCode);
  }
}
